import { Box, CircularProgress, Typography } from '@mui/material'
import { Colors } from 'constants/colors'

import Keyword from 'Keyword/Keyword'
import React from 'react'

export default function HitsTableScrapingStatus({
  status,
}: {
  status: {
    instagram: boolean
    youtube: boolean
    reddit: boolean
    tiktok: boolean
    facebook: boolean
  }
}): JSX.Element {
  return (
    <Box
      sx={{
        backgroundColor: Colors.backgroundDarkGray,
        color: Colors.white,
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography>Please wait a moment, gathering requested data...</Typography>
      <Box>
        {status.instagram && (
          <Keyword
            platform="Instagram"
            text="Instagram"
            sideIcon={
              <CircularProgress
                size={15}
                sx={{ marginTop: '3px', marginLeft: '5px' }}
              />
            }
          />
        )}
        {status.youtube && (
          <Keyword
            platform="Youtube"
            text="Youtube"
            sideIcon={
              <CircularProgress
                size={15}
                sx={{ marginTop: '3px', marginLeft: '5px' }}
              />
            }
          />
        )}
        {status.reddit && (
          <Keyword
            platform="Reddit"
            text="Reddit"
            sideIcon={
              <CircularProgress
                size={15}
                sx={{ marginTop: '3px', marginLeft: '5px' }}
              />
            }
          />
        )}
        {status.tiktok && (
          <Keyword
            platform="TikTok"
            text="TikTok"
            sideIcon={
              <CircularProgress
                size={15}
                sx={{ marginTop: '3px', marginLeft: '5px' }}
              />
            }
          />
        )}
        {status.facebook && (
          <Keyword
            platform="Facebook"
            text="Facebook"
            sideIcon={
              <CircularProgress
                size={15}
                sx={{ marginTop: '3px', marginLeft: '5px' }}
              />
            }
          />
        )}
      </Box>
    </Box>
  )
}
